import * as React from 'react';
import { Button } from '@fluentui/react-components';
import { AddRegular, LockClosedRegular } from '@fluentui/react-icons';
import { Footer } from './Brand';
import { PRODUCT_NAME } from './product';

const NAV: string[] = ['Today', 'Applications', 'Clients', 'Documents', 'History', 'Settings'];

/** A grey bar standing in for text that appears once the firm is set up. */
function Bar(props: { w: string; h?: number }): React.ReactElement {
  return <span className="skeleton" style={{ width: props.w, height: props.h ?? 12 }} />;
}

/**
 * What a firm sees before setup: the app as it will be, locked. The menu and the page are greyed
 * out and do nothing; one card in the middle starts the setup. No sample records are shown, only
 * shapes, so nothing could be mistaken for real data.
 */
export function SetupPreview(props: { started?: boolean; onStart: () => void }): React.ReactElement {
  return (
    <div className="shell">
      <nav className="sidebar" aria-label="Main (available after setup)">
        <div className="nav">
          {NAV.map((n, i) => (
            <a key={n} aria-disabled="true" aria-current={i === 0 ? 'page' : undefined} className="locked" onClick={e => e.preventDefault()} href="#" tabIndex={-1} title="Available after setup">
              {n}
            </a>
          ))}
        </div>
        <Button icon={<AddRegular />} disabled style={{ width: '100%' }}>Open an application</Button>
      </nav>
      <div className="content">
        <main className="page preview-page-wrap" style={{ maxWidth: 908 }}>
          <section className="setup-card" aria-labelledby="setup-h">
            <span className="setup-lock" aria-hidden="true"><LockClosedRegular fontSize={22} /></span>
            <h1 id="setup-h" className="h1" style={{ fontSize: 24 }}>{props.started ? 'Finish setting up your account' : 'Set up your account to get started'}</h1>
            <p className="onb-lead" style={{ textAlign: 'center' }}>
              {PRODUCT_NAME} needs to know where your client files live, who works on them and which programs you handle.
              It takes about 5 minutes, and nothing is created in your SharePoint until the last step.
            </p>
            <Button appearance="primary" size="large" onClick={props.onStart}>{props.started ? 'Continue setup' : 'Set up your account'}</Button>
          </section>

          {/* The dashboard as it will look: shapes only, greyed out and hidden from screen readers. */}
          <div className="locked-page" aria-hidden="true">
            <div className="stack" style={{ gap: 10 }}>
              <Bar w="160px" />
              <Bar w="320px" h={26} />
            </div>
            <div className="needs">
              {[0, 1, 2].map(i => (
                <div key={i} className="task">
                  <span className="flag quiet" />
                  <div className="stack" style={{ gap: 8 }}><Bar w="140px" /><Bar w={['62%', '48%', '55%'][i]} h={16} /><Bar w="38%" /></div>
                  <span className="skeleton" style={{ width: 110, height: 40, borderRadius: 8 }} />
                </div>
              ))}
            </div>
            <div className="rows">
              <Bar w="110px" h={16} />
              {[0, 1, 2].map(i => <div key={i} className="row"><Bar w="48px" /><Bar w={['52%', '64%', '44%'][i]} /></div>)}
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
}
